var _style, _polygon, _path, _path2, _polygon2, _path3, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1072.6 240",
    style: {
      enableBackground: "new 0 0 1072.6 240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#312782;}\n\t.st1{fill:#009EE2;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.8,66.5 21.8,109.5 10,109.5 10,129.7 21.8,129.7 21.8,222 43.4,222 43.4,129.7 64.6,129.7  64.6,109.5 43.4,109.5 43.4,66.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.4,127.8h0.7c5.3-13.2,16.3-21.6,30.8-21.6c6.3,0,12.5,2.2,17.8,5.5l-9.9,19.7c-3.8-3.4-8.2-4.6-13.2-4.6 c-23.3,0-26.2,21.6-26.2,39.9V222H77.8V109.5h21.6V127.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.6,222h-21.6v-17.6h-0.5c-8.7,12.7-22.1,21.4-38.2,21.4c-34.4,0-53.9-28.6-53.9-60.8 c0-30.8,20.4-58.9,53.1-58.9c16.6,0,30,8.7,38.9,22.1h0.5v-18.8h21.6V222z M239.1,165.8c0-21.9-13.2-40.4-36.5-40.4 c-22.4,0-35.6,19.5-35.6,40.4c0,21.2,12.7,40.9,35.6,40.9C226.2,206.6,239.1,187.9,239.1,165.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "326.2,179.7 404.1,13.3 428.4,13.3 326.2,225.9 269.7,109.5 293.9,109.5 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401,169.4c0.2,19.2,13.2,37.3,33.9,37.3c16.6,0,25.5-8.4,33.7-21.9l18.3,10.3c-10.6,19.5-30.3,30.8-52.2,30.8 c-34.4,0-55.3-26-55.3-59.1c0-34.6,18.5-60.6,54.8-60.6c35.8,0,52.7,26.4,52.7,59.9v3.4H401z M465.2,153 c-2.6-16.8-13.7-28.1-31-28.1c-16.8,0-29.3,12-32,28.1H465.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 502.9,
    y: 13.3,
    className: "st0",
    width: 21.6,
    height: 208.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M554.6,201.1c6.5,0,12,5.5,12,12c0,6.5-5.5,12-12,12c-6.5,0-12-5.5-12-12C542.6,206.6,548.1,201.1,554.6,201.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M671.8,150.9c-9.1-11.5-22.3-14.9-31.2-14.9c-18.5,0-35.3,13-35.3,37.2s17.3,37,35.1,37 c10.3,0,23.1-4.6,32.2-15.6v20.7c-10.8,7.9-22.3,10.3-31.7,10.3c-31,0-53.3-22.1-53.3-52.1c0-30.5,22.6-52.9,53.3-52.9 c15.9,0,26.2,6.2,31,9.6V150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M687.9,173.2c0-30.3,22.3-52.6,52.9-52.6c30.5,0,52.9,22.3,52.9,52.6s-22.6,52.4-52.9,52.4 C710.5,225.6,687.9,203.5,687.9,173.2z M705.7,173.2c0,24.5,17.3,37,35.1,37c18,0,35.1-12.7,35.1-37c0-24.5-16.8-37.2-35.1-37.2 C722.5,136,705.7,148.9,705.7,173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M826.3,201.1c6.5,0,12,5.5,12,12c0,6.5-5.5,12-12,12c-6.5,0-12-5.5-12-12C814.3,206.6,819.8,201.1,826.3,201.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M882.7,181.1c0,7,0,15.1,4.8,21.4c2.6,3.4,7.9,7.7,17.5,7.7s14.9-4.3,17.5-7.7c4.8-6.2,4.8-14.4,4.8-21.4V123 h17.3v60.1c0,12.3-1.2,21.4-9.1,30c-8.9,9.4-20.7,12.5-30.5,12.5c-9.9,0-21.6-3.1-30.5-12.5c-7.9-8.6-9.1-17.8-9.1-30V123h17.3 V181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M990.1,47.5V160l36.5-37h22.6l-42.8,42.8l50.5,56.9h-22.6l-39.9-45.4l-4.3,4.3v41.1h-17.3V47.5H990.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.8592771650ef2a974e570d391c19c66e.svg";
export { ForwardRef as ReactComponent };